import React, { useState } from "react";
import RequestService from "../../services/request.service";

import './gerencia.scss';
// import '../Reportes/mi_reporte.scss';

import moment from 'moment'
import { toast } from 'react-toastify'



import AuthService from "../../features/auth/auth.service";

import { Tab, Tabs, Row, Col, Nav } from 'react-bootstrap'


import { useParams, Link } from 'react-router-dom';



// import HeatMap from '@uiw/react-heat-map';





		import {
		  Chart as ChartJS,
		  CategoryScale,
		  LinearScale,
		  BarElement,
		  Title,
		  Tooltip,
		  Legend,
		  Ticks,
		  ArcElement
		} from 'chart.js';

		// import { getRelativePosition } from 'chart.js/helpers';


		import { Bar } from 'react-chartjs-2';


		ChartJS.register(
		  CategoryScale,
		  LinearScale,
		  BarElement,
		  Title,
		  Tooltip,
		  Legend,
		  ArcElement
		);





const currencyFormat = (num) => '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')




const ReporteMensual = ( props ) => {



	// const { reporteData } = props

// const labels = [""];

// const [checked, setChecked] = useState(false);
const checked = false

const options = {
    scales: {
        x: {
            ticks: {
                // Include a dollar sign in the ticks
                callback: function(value, index, ticks) {
                    return '$' + Ticks.formatters.numeric.apply(this, [value, index, ticks]);
                },
                color: (checked ?  'white' : 'black')
            },
            grid: {
              color: (checked ?  'white' : '#f2f2f2'),
              // borderColor: '#2b8f90',
              // lineWidth : 3
            }
        },
        y: {
            ticks: {
                color: (checked ?  'white' : 'black')
            },
            grid: {
              color: (checked ?  'white' : '#f2f2f2'),
              // borderColor: '#2b8f90',
              // lineWidth : 3
            }
        }
    },
    indexAxis: 'y' as const,
    elements: {
        bar: {
            borderWidth: 2,
        },
    },
    responsive: true,
    plugins: {
        legend: {
            display: false
        },
        title: {
            display: true,
            text: 'Estatus por Trámite por Día',
        },
    },


};


  const { reporteData } = props




const data = {
          labels : reporteData.reporteData.etiquetas,
          datasets: [
            {
              label: 'Monto',
              data: reporteData.reporteData.data,
              borderColor: '#247879',
              backgroundColor: '#36b3b4',
            },
          ],
        };






// const dona = {
//   labels: ['Red', 'Blue'],
//   datasets: [
//     {
//       label: '# of Votes',
//       data: [80,20],
//       backgroundColor: [
//         '#247879',
//         'rgba(255,255,255,0)',
//       ],
//       borderColor: [
//         '#36b3b4',
//         '#247879',
//       ],
//       borderWidth: 1,
//     },
//   ],
// };
  //   const options_ = {
  //     responsive: false,
  //     maintainAspectRatio: false,

  //       rotation: -90,
  //       circumference: 180,

  // plugins: {
  //  legend: {
  //   display: false
  //  },
  //   title: {
  //     display: true,
  //     text: 'Meta del Mes',
  //   },
  // },
  //   }







	return (
		<>

					<h3>REPORTE DEL MES DE {moment(reporteData.fecha_reporte).format('MMMM').toUpperCase()}</h3>


                  <div className="row">
                    <div className="col-sm-5">

                        <div className="row row-cols-3">
                          <div className="col">
                                <small><b>Total </b></small>
                                <h2>{reporteData.total_folios_mes}</h2>
                          </div>
                          <div className="col">
                                <small>En Gestión</small>
                                <h3>{reporteData.total_en_gestion}</h3>
                          </div>
                          <div className="col">
                                <small>Aceptados</small>
                                <h3>{reporteData.total_aceptados}</h3>
                          </div>
                          <div className="col">
                                <small>Sin Cobrar</small>
                                <h3>{reporteData.total_no_cobrado}</h3>
                          </div>
                          <div className="col">
                                <small>Finiquitado</small>
                                <h3>{reporteData.total_finiquitado}</h3>
                          </div>
                          <div className="col">
                                <small>Cancelados</small>
                                <h3>{reporteData.total_cancelados}</h3>
                          </div>
                        </div>


                          {
                          	// <Doughnut className="mb-4 mt-2" data={dona} width="420px" height="140px" options={options_}  />
                          }

                          {
                          	// JSON.stringify(reporteData.reporteData.etiquetas)
                          }

                          <Bar options={options} data={data} width="100%" height={300} />

                    </div>

                    <div className="col-sm-7">
                        {
                          // JSON.stringify(reporteData.reporte_por_semanas)
                        }

                        <table className="table table-striped table-sm" >
                          <tbody>

                            {

                              reporteData.reporte_por_semanas.map( (semana:any, i:number) =>

                                  <React.Fragment key={i}>

                                    <tr >
                                      <td style={{padding: '4px 2px', fontSize: '10px'}}>
                                        <small style={{color : (checked ?  'white' : 'black')}}>SEMANA {(i+1)}</small>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{padding:0}}>
                                        


                                            <table className="table table-sm" style={{color : (checked ?  'white' : 'black'), marginBottom: 0}}>
                                              <thead style={{fontSize:5}}>
                                                <tr>
                                                  <th scope="col">Día</th>
                                                  <th scope="col">Total</th>
                                                  <th scope="col">En Gestión</th>
                                                  <th scope="col">Aceptados</th>
                                                  <th scope="col">No Cobrados</th>
                                                  <th scope="col">Finiquitados</th>
                                                  <th scope="col">Cancelados</th>
                                                  <th scope="col"></th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                              {
                                                semana.dias.map( dia =>

                                                      <tr key={dia.dia}>
                                                        <th scope="row" className="text-right chiquitos" style={{width: 80}}>
                                                          <small>{dia.dia}</small>
                                                        </th>
                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                          <small>{(dia.cantidad)}</small>
                                                        </td>

                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                          <small>{(dia.en_gestion)}</small>
                                                        </td>
                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                          <small>{(dia.aceptados)}</small>
                                                        </td>
                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                          <small>{(dia.no_cobrado)}</small>
                                                        </td>
                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                          <small>{(dia.finiquitado)}</small>
                                                        </td>
                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                          <small>{(dia.cancelados)}</small>
                                                        </td>




                                                        <td className="text-right chiquitos">
                                                          <small>{currencyFormat(dia.monto)}</small>
                                                        </td>
                                                      </tr>

                                                  )
                                              }

                                                      <tr>
                                                        <th scope="row" className="text-right chiquitos">
                                                          <small><b>TOTAL</b></small>
                                                        </th>
                                                        <td className="text-right chiquitos">
                                                          <small>{(semana.total_folios)}</small>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td className="text-right chiquitos">
                                                          <small>{currencyFormat(semana.monto_total)}</small>
                                                        </td>
                                                      </tr>


                                              </tbody>
                                            </table>



                                      </td>
                                    </tr>

                                  </React.Fragment>

                                )

                            }


                          </tbody>
                        </table>


                    </div>
                  </div>




		</>
	)

}





const ReporteGerencial = () =>{

  // let navigate = useNavigate();
  let { year } = useParams();

      const currentUser  = AuthService.getCurrentUser();


  const [ cargando_, setCargando ] = useState( true )

  const [ reporte, setReporte ] = useState<any>({ })

  const cargarMiReporte = async(fecha:any)=>{
      try{
        setCargando(true)
        let response = await RequestService.getEndPoint('gerencia/reporte/'+currentUser.uuid+'/'+fecha)
        setReporte(response.data)
        setCargando(false)
      }
      catch(e){
        setCargando(false)
        toast.error('Problemas al intentar generar tu reporte. Contacta con los administradores del sistema')
      }
    }


  React.useEffect(() => {
    cargarMiReporte( year )
    setKey(0)
    setKeyKey(0)
  }, [ year ]);


	// const [ anio_reporte, setAnio ] = useState(parseInt(moment().format('YYYY')))

  // const anios_reporte = [{year:2020},{year:2021},{year:2022}]

 //  const cambiarAnio = async (year:number) => {

 //  	setAnio(year)
 //  	// setKey(0)
  	
 //  	// await cargarMiReporte(year)


 //    navigate('/gerencia/reporte/'+year);

 // //  	setStartDate( moment( year + '-01-01' ).toDate() )
	// // setEndDate( moment( (year+1) + '-01-01' ).toDate() )	

 //  }


  const [key, setKey] = useState<any>(0);
  const [keykey, setKeyKey] = useState<any>(0);


  // const [keyMeses, setKeyMeses] = useState(0);

	return (


		<>

			 <div className="container">

	                {  cargando_ && (

                      <>
                        <div className="loader">
                          <div className="loaderBar"></div>
                        </div>
                      </>


                   )}
	 	



	                {  !cargando_ && (

                      <>

                        <div className="row">
                          <div className="col-sm-8">
                            
                            <h5>Reporte Gerencial</h5>
                            <p>Reporte Analítico de Tramites por Departamento y Estatus para el año {year}</p>

                          </div>
                          <div className="col-sm-4 text-right">
                                  
                              <p className="nm mt-4">Opciones</p>
                              <ul className="list-inline">
                                  {
                                    reporte.years.map((anio:any)=>
                                      <li className="list-inline-item" key={ Math.random().toString(36).substr(2, 9) }>
                                        <Link className={ anio.year.toString() === year ? 'disabled-link' : '' } to={'/gerencia/reporte/'+anio.year}><small>{anio.year.toString()}</small></Link>
                                      </li>
                                    )
                                  }
                              </ul>

                          </div>
                        </div>
                        
                      	

                      	<hr />




                      	<div className="row">

                      		<div className="col-sm-6">

{
	// JSON.stringify(reporte.reporte_mensual_departamental)
}




<Tab.Container id="left-tabs-example"
                    activeKey={key}
                    onSelect={(k) =>{ setKey(k); setKeyKey(0); }}
                    defaultActiveKey="first">
  <Row>
    <Col sm={3}>
      <Nav variant="pills" className="flex-column">

{
	reporte.reporte_mensual_departamental.map( (mes:any, indice : number) =>
        <Nav.Item key={ Math.random().toString(36).substr(2, 9) }>
          <Nav.Link style={{fontSize:9, padding: '0.3rem 1rem'}} eventKey={indice}>{mes.mes}</Nav.Link>
        </Nav.Item>
    )
}
      </Nav>
    </Col>
    <Col sm={9}>
      <Tab.Content style={{padding:'0px 0 0 0'}}>
{
	reporte.reporte_mensual_departamental.map( (mes:any, indice : number) =>
        <Tab.Pane key={ Math.random().toString(36).substr(2, 9) } eventKey={indice}>
          


          				<h6>REPORTE ACUMULADOS DEL MES DE {mes.mes}</h6>

                <div className="table-responsive">

								<table className="table table-sm" style={{fontSize:10}}>
								  <thead>
								    <tr>
								      <th scope="col">Departamento</th>
								      <th scope="col">Cantidad</th>
								      <th className="estatus_1" scope="col">En Gestión</th>
								      <th className="estatus_4" scope="col">Aceptado</th>
								      <th className="estatus_5" style={{color:'white'}} scope="col">No Cobrado</th>
								      <th className="estatus_6" scope="col">Finiquitado</th>
								    </tr>
								  </thead>
								  <tbody>
								  {
								  	mes.departamentos.map(departamento =>
								  		<React.Fragment key={ Math.random().toString(36).substr(2, 9) }>

											    <tr>
											      <td>
											      	<small>{ departamento.departamento.toUpperCase() }</small>
											      </td>
											      <td className="text-right" style={{width:80}}>
											      	<b>{departamento.data.cantidad}</b>
											      </td>
											      <td className="estatus_1_ text-right" style={{width:80}}>
											      	{departamento.data.en_gestion}
											      </td>
											      <td className="estatus_4_ text-right" style={{width:80}}>
											      	{departamento.data.aceptados}
											      </td>
											      <td className="estatus_5_ text-right" style={{width:80}}>
											      	{departamento.data.no_cobrado}
											      </td>
											      <td className="estatus_6_ text-right" style={{width:80}}>
											      	{departamento.data.finiquitado}
											      </td>
											    </tr>

								  		</React.Fragment>
								  	)
								  }

								  </tbody>
								</table>

                </div>



        </Tab.Pane>
    )
}
      </Tab.Content>
    </Col>
  </Row>
</Tab.Container>




                      		</div>
                      		<div className="col-ms-6">
                      			{
                      				// JSON.stringify(reporte.reporte_departamento)
                      			}

                      			<h6>REPORTE DE TRÁMITES POR ESTATUS</h6>

                            <div className="table-responsive">

            								<table className="table table-sm" style={{fontSize:10}}>
            								  <thead>
            								    <tr>
            								      <th scope="col">Departamento</th>
            								      <th scope="col">Cantidad</th>
            								      <th className="estatus_1" scope="col">Captura</th>
            								      <th className="estatus_1" scope="col">Verificación</th>
            								      <th className="estatus_1" scope="col">Rectificación</th>
            								      <th className="estatus_4" scope="col">Aceptado</th>
            								      <th className="estatus_5" style={{color:'white'}} scope="col">No Cobrado</th>
            								      <th className="estatus_6" scope="col">Finiquitado</th>
            								    </tr>
            								  </thead>
            								  <tbody>
            								  {
            								  	reporte.reporte_departamento.map(departamento =>
            								  		<React.Fragment key={ Math.random().toString(36).substr(2, 9) }>

            											    <tr>
            											      <td>
            											      	<small>{ departamento.departamento.toUpperCase() }</small>
            											      </td>
            											      <td className="text-right" style={{width:80}}>
            											      	<b>{departamento.totales}</b>
            											      </td>
            											      <td className="estatus_1_ text-right" style={{width:80}}>
            											      	{departamento.captura}
            											      </td>
            											      <td className="estatus_1_ text-right" style={{width:80}}>
            											      	{departamento.verificacion}
            											      </td>
            											      <td className="estatus_1_ text-right" style={{width:80}}>
            											      	{departamento.rectificacion}
            											      </td>
            											      <td className="estatus_4_ text-right" style={{width:80}}>
            											      	{departamento.espera}
            											      </td>
            											      <td className="estatus_5_ text-right" style={{width:80}}>
            											      	{departamento.no_cobrado}
            											      </td>
            											      <td className="estatus_6_ text-right" style={{width:80}}>
            											      	{departamento.finiquitado}
            											      </td>
            											    </tr>

            								  		</React.Fragment>
            								  	)
            								  }

            								  </tbody>
            								</table>

                            </div>





                      		</div>
                      		
                      	</div>


                        {
                        	
                        }



							    <Tabs
							      id="controlled-tab-example"
							      activeKey={key}
							      onSelect={(k) =>{ setKey(k); setKeyKey(0); }}
							      
							    >

							      	{
							      		
							      		reporte.analitica_reporte_mensual.map( (data : any, i : number) =>

							      			<Tab key={i} eventKey={i} title={data.mes.toUpperCase()}>

                              {
                                // JSON.stringify(data)
                              }




                                          <Tabs
                                            id="controlled-tab-reportemensual"
                                            activeKey={keykey}
                                            onSelect={(k) => setKeyKey(k)}
                                            
                                          >

                                              {
                                                
                                                data.analitica_departamento.map( (data_2 : any, indx : number) =>

                                                  <Tab key={indx} eventKey={indx} title={data_2.departamento.toUpperCase()}>

                                                      {
                                                        // JSON.stringify(data_2)
                                                      }

                                                            <>
                                                          <div className="row">
                                                            <div className="col-md-7">
                                                              {

                                                                <ReporteMensual reporteData={data_2}  />
                                                              }
                                                            </div>
                                                            <div className="col-md-5">

                                                              <div className="table-responsive">

                                                                <table className="table">
                                                                  <thead>
                                                                    <tr>
                                                                      <th scope="col">Gerentes</th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                  {
                                                                    data_2.por_gerente.map( gerente =>

                                                                      <tr key={gerente.uuid_usuario}>
                                                                        <td>
                                                                          <p className="nm"><b>{gerente.nombres}</b> <small>{gerente.paterno} {gerente.materno}</small></p>
                                                                          


                                                                            <p style={{fontSize:9}} className="nm"><b><small>ASESORES</small></b></p>



                                                                            <table className="table table-sm" style={{ marginBottom: 0}}>
                                                                              <thead style={{fontSize:5}}>
                                                                                <tr>
                                                                                  <th scope="col">Día</th>
                                                                                  <th scope="col">Total</th>
                                                                                  <th scope="col">En Gestión</th>
                                                                                  <th scope="col">Aceptados</th>
                                                                                  <th scope="col">No Cobrados</th>
                                                                                  <th scope="col">Finiquitados</th>
                                                                                  <th scope="col">Cancelados</th>
                                                                                  <th scope="col"></th>
                                                                                </tr>
                                                                              </thead>
                                                                              <tbody>
                                                                              {
                                                                                gerente.asesores.map( asesor =>

                                                                                      <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                                                        <th scope="row" className="text-right chiquitos" style={{width: 150, fontSize:8}}>
                                                                                          <small><b>{asesor.nombres}</b></small> {asesor.paterno} {asesor.materno}
                                                                                        </th>
                                                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                                                          <small>{(asesor.tots)}</small>
                                                                                        </td>

                                                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                                                          <small>{asesor.en_gestion}</small>
                                                                                        </td>
                                                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                                                          <small>{asesor.aceptados}</small>
                                                                                        </td>
                                                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                                                          <small>{asesor.no_cobrado}</small>
                                                                                        </td>
                                                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                                                          <small>{asesor.finiquitado}</small>
                                                                                        </td>
                                                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                                                          <small>{asesor.cancelados}</small>
                                                                                        </td>




                                                                                        <td className="text-right chiquitos">
                                                                                          <small>{currencyFormat(Math.round(asesor.monto_))}</small>
                                                                                        </td>
                                                                                      </tr>

                                                                                  )
                                                                              }


                                                                              </tbody>
                                                                            </table>


                                                                        </td>
                                                                      </tr>

                                                                    )
                                                                  }

                                                                  </tbody>
                                                                </table>

                                                             </div>


                                                                  {
                                                                    data_2.asesores_sin_gerente.length > 0 && (
                                                                      <h6>Asesores</h6>
                                                                    )
                                                                  }
                                                                  

                                                                  <ol className="list-group list-group-numbered">

                                                                    {
                                                                      data_2.asesores_sin_gerente.map( asesores =>


                                                                          <li key={asesores.uuid_usuario} className="list-group-item d-flex justify-content-between align-items-start">
                                                                            <div className="ms-2 me-auto">
                                                                              <p><b>{asesores.nombres}</b> <small className="chiquito">{asesores.paterno} {asesores.materno}</small></p>
                                                                              
                                                                            </div>
                                                                            <span className="badge bg-primary rounded-pill">{asesores.tots}</span>
                                                                          </li>

                                                                      )
                                                                    }

                                                                  </ol>



                                                            </div>
                                                          </div>
                                                            </>

                                                  </Tab>

                                                )
                                              }

                                          </Tabs>






							      			</Tab>

							      		)
							      	}

							    </Tabs>







                      </>


                   )}

			 </div>

		</>


	)


}


export default ReporteGerencial